import Compressor from 'compressorjs';

export function optimiseImage({
  file,
  ...options
}: {
  file: File | Blob;
} & Compressor.Options): Promise<File | Blob> {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      ...options,
      success: result => {
        resolve(result);
      },
      error: err => {
        reject(err);
      },
    });
  });
}
